import _createClass from "@babel/runtime/helpers/esm/createClass";
import Polyglot from 'node-polyglot';

var PolyglotAdapter = /*#__PURE__*/function () {
  function PolyglotAdapter() {
    this.polyglot = new Polyglot();
  }

  var _proto = PolyglotAdapter.prototype;

  _proto.translate = function translate(key, values) {
    return this.polyglot.t(key, values);
  };

  _createClass(PolyglotAdapter, [{
    key: "instance",
    get: function get() {
      return this.polyglot;
    }
  }, {
    key: "locale",
    get: function get() {
      return this.polyglot.locale();
    },
    set: function set(locale) {
      return this.polyglot.locale(locale);
    }
  }, {
    key: "translations",
    set: function set(translations) {
      this.polyglot.extend(translations);
    }
  }]);

  return PolyglotAdapter;
}();

export { PolyglotAdapter as default };